import { AxiosApi, ApiResult } from './axiosApi';
import {
    AlarmNotificationSubscription,
    AlarmNotificationSubscriptionCreateRequest,
    AlarmNotificationSubscriptionUpdateRequest,
} from '../dtos/alarmNotificationSubscription';

export class AlarmNotificationSubscriptionApi extends AxiosApi<AlarmNotificationSubscription> {
    constructor(baseUri: string, logout?: () => void, enqueueSnackbar?: any) {
        super(baseUri, 'alarm-subscriptions', logout, enqueueSnackbar);
    }

    public getAllForSite = (orgId: number, siteId: number, abortController?: AbortController) =>
        this.genericRequest({
            method: 'GET',
            overridePath: `organizations/${orgId}/sites/${siteId}/${this._resourceName}`,
            abortController,
        }) as Promise<ApiResult<AlarmNotificationSubscription[]>>;

    public getByIdForSite = (
        orgId: number,
        siteId: number,
        id: number,
        abortController?: AbortController
    ) =>
        this.genericRequest({
            method: 'GET',
            overridePath: `organizations/${orgId}/sites/${siteId}/${this._resourceName}/${id}`,
            abortController,
        }) as Promise<ApiResult<AlarmNotificationSubscription>>;

    public createForSite = (
        orgId: number,
        siteId: number,
        request: AlarmNotificationSubscriptionCreateRequest,
        abortController?: AbortController
    ) =>
        this.genericRequest({
            method: 'POST',
            data: request,
            overridePath: `organizations/${orgId}/sites/${siteId}/${this._resourceName}`,
            abortController,
        }) as Promise<ApiResult<AlarmNotificationSubscription>>;

    public updateForSite = (
        orgId: number,
        siteId: number,
        id: number,
        request: AlarmNotificationSubscriptionUpdateRequest,
        abortController?: AbortController
    ) =>
        this.genericRequest({
            method: 'PUT',
            data: request,
            overridePath: `organizations/${orgId}/sites/${siteId}/${this._resourceName}/${id}`,
            abortController,
        }) as Promise<ApiResult<AlarmNotificationSubscription>>;

    public deleteForSite = (
        orgId: number,
        siteId: number,
        id: number,
        abortController?: AbortController
    ) =>
        this.genericRequest({
            method: 'DELETE',
            overridePath: `organizations/${orgId}/sites/${siteId}/${this._resourceName}/${id}`,
            abortController,
        }) as Promise<ApiResult<void>>;
}
